
import React, { useEffect, useMemo } from 'react';
import { Mutation, useQuery } from 'react-apollo';
import { adminPantrySites, deletePantryReservation, reservations } from '../../apollo';
import { Box, Button, FormControl, Grid, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from '@material-ui/core';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import ConfirmDialog from '../confirm-dialog/confirm-dialog';
import { RefreshOutlined } from '@material-ui/icons';
import { randomUUID } from 'crypto';
import pantrySites from '../../apollo/queries/pantrySites';
import { getReferralSourceName } from '../../constants/referralSources';


const ReservationList = () => {
  const { data, error, loading, refetch } = useQuery(reservations, { notifyOnNetworkStatusChange: true });
  const { data: data2, error: error2, loading: loading2, refetch: refetch2 } = useQuery(adminPantrySites, { notifyOnNetworkStatusChange: true });
  const [order, setOrder] = React.useState('');
  const [visibleRows, setVisibleRows] = React.useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);

  useEffect(() => {
    if (!loading && !loading2)
      setVisibleRows(data.reservations.map((el:any) => {
      const pantry = (data2.adminPantrySites.pantries || []).find((ele:any) => ele.Pantry == el.Pantry)
      return {
        ...el, pantryName: pantry.Name, pantrySite: pantry.Address1 + ' ' + pantry.Address2 +', ' + pantry.Zip }  
      }).filter((el:any) => el.FirstName.toLowerCase().includes(order.toLowerCase()))
      .map((el:any) => ({...el, randomID: generateRandom()})))},
    [order, data, data2]
  );

  const referralSourceOptions = useMemo(() => {
    const values = (data?.reservations || [])
      .map((el:any) => el.ReferralSource)
      .filter((value:any) => value != null && value !== '');
    return (Array.from(new Set(values)) as string[]).sort()
      .map((slug) => ({ value: slug, label: getReferralSourceName(slug) || slug }));
  }, [data]);


  const closeDialog = () => setOpenDialog(false);
  const columns: GridColDef[] = [
    { field: 'Key_ID', headerName: 'Key ID', width: 130 },
    { field: 'FirstName', headerName: 'First name', width: 130 },
    { field: 'LastName', headerName: 'Last name', width: 130 }, 
    { field: 'pantryName', headerName: 'Partner Name', width: 400 }, 
    { field: 'pantrySite', headerName: 'Partner Address', width: 500 }, 
    { field: 'Email', headerName: 'Email', width: 300 }, 
    //{ field: 'City', headerName: 'City', width: 150 }, 
    //{ field: 'State', headerName: 'State', width: 50 }, 
    { field: 'Zip', headerName: 'Zip', width: 80 }, 
    { field: 'HomePhone', headerName: 'Home Phone', width: 120 }, 
    //{ field: 'WorkPhone', headerName: 'Work Phone', width: 120 }, 
    { field: 'Volunteer', headerName: 'Volunteer', width: 80,
    valueFormatter: ({ value }) => (value ? 'Yes' : 'No'),
    renderCell: (params) => {
        return (
            <Typography>
                {params.row.Volunteer ? 'Yes': 'No'}
            </Typography>
        );
      }, 
    }, 
    { field: 'ReferralSource', headerName: 'Referred By', width: 160, type: 'singleSelect', valueOptions: referralSourceOptions },
    { field: 'ServeDate', headerName: 'Serve Date', width: 300 }, 
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      sortable: false,
      disableExport: true,
      renderCell: (params) => {
          return (
              <>
                  <Button
                      onClick={() => setOpenDialog(params.row.Key_ID)}
                      color={'secondary'}
                      variant={'contained'}
                      size={'small'}
                  >
                      Delete
                  </Button>
              </>
          );
      },
    },
  ];

  const  generateRandom = () => {
    var length = 12,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const showDialog = (
    <Mutation
      mutation={deletePantryReservation}
      variables={{ input: { Key_ID: openDialog } }}
      refetchQueries={[
        { query: reservations },
      ]}
      onError={(mutationError:any) => alert(mutationError)}
      onCompleted={() => {
        const copy = [...visibleRows];
        setVisibleRows(copy.filter((el:any) => el.Key_ID != openDialog));
        setOpenDialog(false);
        alert('Delete Successful');
      }}
      
    >
      {(deletePantryReservation:any,loading:any) => {

        return (
          <ConfirmDialog loading={loading} close={closeDialog} confirm={deletePantryReservation}>
            <Typography>
                Are you sure you want to delete?
            </Typography>
          </ConfirmDialog>
        );
      }}
    </Mutation>);

  return ( (!loading && !loading2) ? 
        <Box>
          <>
          <Grid container spacing={2}>
            <Grid item xs={11}>
            <Box padding={2}><FormControl fullWidth><TextField onChange={(e) => setOrder(e.target.value)} id="outlined-basic" label="Search" variant="outlined" /></FormControl></Box>
            </Grid>
            <Grid  item xs={1}>
            <IconButton style={{marginBlockStart:25}} onClick={() => {
              refetch()}} aria-label="delete">
              <RefreshOutlined fontSize='medium' />
            </IconButton>
            </Grid>
          </Grid>
          <DataGrid
            getRowId={(row) => row.randomID}
            rows={visibleRows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 100 },
              }
            }}
            pageSizeOptions={[50, 100]}
            checkboxSelection={false}
            slots={{ toolbar: GridToolbar }}
            slotProps={{ toolbar: { csvOptions: { disableToolbarButton: true }, printOptions: { disableToolbarButton: true } } }}
          />
          {openDialog && showDialog}
          </>
        </Box>:
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
  );
};

export default ReservationList;
